.page {
  padding: 20px;

  img {
    width: 350px;
    height: 350px;
  }

  a {
    color: #1854d5;
  }

  .list {
    padding: 0 50px;
    height: 50px;
    display: flex;
    align-items: center;
    background-color: #1854d5;
    color: #ffffff;
    font-weight: bold;
    border-radius: 15px;

    cursor: pointer;
    transition: transform 200ms;

    &:hover {
      transform: scale(1.02);
    }

    &:active {
      transform: scale(1);
    }
  }

  .listModal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background-color: #00000060;
    display: flex;
    align-items: center;
    justify-content: center;

    .dialog {
      padding: 20px;
      border-radius: 20px;
      background-color: #ffffff;

      h3 {
        margin-top: 0;
      }

      input {
        width: 100%;
        padding: 15px 20px;
        background-color: #f5f5f5;
        border-radius: 15px;
        margin-bottom: 15px;
        font-size: 16px;
      }

      .btn {
        padding: 0 50px;
        height: 50px;
        display: flex;
        align-items: center;

        background-color: #f0f0f0;
        color: #000000;

        &.confirm {
          background-color: #1854d5;
          color: #ffffff;
          font-weight: bold;
        }

        border-radius: 15px;

        cursor: pointer;
        transition: transform 200ms;

        &:hover {
          transform: scale(1.02);
        }

        &:active {
          transform: scale(1);
        }
      }
    }
  }
}
